<pre>
    {{cUser.localisation|json}}
</pre>
